export const meta = { id: 'O24', slug: 'criar-etapas', title: 'Como criar Etapas', description: 'Organize a Formação em momentos coerentes de desenvolvimento.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 540, keywords: ['etapas','formação','currículo','sequência'], previous: 'O23', next: 'O25', related: ['O23','O25'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar Etapas

Etapas dividem a Formação em momentos coerentes do percurso.

<HelpImage pendingId="O24.1" alt="Criação ou edição de Etapa da Formação" />

<Steps>
  <Step title="Defina o propósito da Etapa">Pense no que o participante deve desenvolver nesse momento.</Step>
  <Step title="Crie a Etapa">Informe os dados disponíveis e posicione-a no currículo.</Step>
  <Step title="Adicione Componentes">Inclua as experiências necessárias para cumprir o objetivo da Etapa.</Step>
  <Step title="Revise a progressão">Confirme se a passagem entre Etapas faz sentido.</Step>
</Steps>

<Callout type="tip">Uma Etapa deve representar um momento de desenvolvimento, não apenas servir como agrupamento visual.</Callout>
